module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAAAQCAYAAABAzrJtAAAAfElEQVRYhe2XSwqAMAxEG/F03sareqFqxEoYQ91pYeZBFt2FR361elDEzbJuxSTlyfR3AiMiKQnUUszsDIRWisvwceqBYiilNCEN3DXz1wmNRKyQKIZWClZLfFO2j9M7z2il9JCUBEop2RqO0A5aFKPtc5ENW/8lU7bPGzvvWS8zdttuuQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/zbtb1-2.png
// module id = 733
// module chunks = 0